import { render, staticRenderFns } from "./ImportDatabase.vue?vue&type=template&id=234a7de4&scoped=true"
import script from "./ImportDatabase.vue?vue&type=script&lang=js"
export * from "./ImportDatabase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234a7de4",
  null
  
)

export default component.exports